angular.module('app').config(ticketsRouting);

function ticketsRouting($routeProvider) {
  //?lang=:language
  $routeProvider.when('/:subdomain/tickets/:option/:id/:companyApiKey', {
    pageTitle: 'TICKETS',
    template: '<tickets></tickets>',
    authReq: false,
  });
}

ticketsRouting.$inject = ['$routeProvider'];
